import { requestGQL } from 'common/graphQlClient';
import { isTestEnv } from 'config';
import { useMemo } from 'react';
import { useQuery } from 'react-query';

import { G } from '@mobily/ts-belt';

import { GET_WORK_SESSION, GetWorkSessionResponse } from '../api';

export const parseWorkSession = (response: GetWorkSessionResponse) => {
  return response.propertyById.activeWorkSession;
};

export const workSessionByPropertyIdKey = (propertyId: null | number) => ['workSession', propertyId] as const;
export const fetchWorkSessionByPropertyId = (propertyId: null | number) => () =>
  requestGQL<GetWorkSessionResponse>(GET_WORK_SESSION, { id: propertyId });

export const useActiveWorkSession = (propertyId: null | number) => {
  const { data, isLoading, isError } = useQuery(
    workSessionByPropertyIdKey(propertyId),
    fetchWorkSessionByPropertyId(propertyId),
    {
      enabled: G.isNotNullable(propertyId),
      refetchOnWindowFocus: false,
      retry: isTestEnv ? 0 : 3,
      staleTime: 0,
      select: parseWorkSession,
    },
  );

  const id = useMemo(() => data?.id ?? null, [data]);
  const createdBy = useMemo(() => data?.createdBy ?? null, [data]);

  return {
    data,
    id,
    createdBy,
    isInstallationOngoing: !isLoading && id != null,
    isLoading,
    isError,
  };
};
